import { render } from "./HowtoCategories.vue?vue&type=template&id=681ad77f&scoped=true"
import script from "./HowtoCategories.vue?vue&type=script&lang=js"
export * from "./HowtoCategories.vue?vue&type=script&lang=js"

import "./HowtoCategories.vue?vue&type=style&index=0&id=681ad77f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681ad77f"]])

export default __exports__